import React, { Component } from 'react';

var avatarImage = {
  backgroundImage: 'url(https://s3.amazonaws.com/uifaces/faces/twitter/kurtvarner/128.jpg)',
}

const ExampleAvatars = () =>
  <section id="avatars">
    <h3 className="section-header">Avatars</h3>
    <div className="row medium-up-2">
      <div className="column">
        <h4>.avatar.avatar-round.avatar-sm</h4>
        <div className="avatar avatar-round avatar-sm" style={avatarImage}></div>
        <p>Used in:</p>
        <ul>
          <li>Entry Comments</li>
          <li>Brief Updates</li>
        </ul>
      </div>
      <div className="column">
        <h4>.avatar.avatar-round.avatar-md</h4>
        <div className="avatar avatar-round avatar-md" style={avatarImage}></div>
        <p>Used in:</p>
        <ul>
          <li>Brief Comments</li>
        </ul>
      </div>
      <div className="column">
        <h4>.avatar.avatar-square.avatar-sm</h4>
        <div className="avatar avatar-square avatar-sm" style={avatarImage}></div>
        <p>Used in:</p>
        <ul>
          <li>Header</li>
          <li>Creative Browse Mobile</li>
          <li>Dashboard</li>
        </ul>
      </div>
      <div className="column">
        <h4>.avatar.avatar-square.avatar-lg</h4>
        <div className="avatar avatar-square avatar-lg" style={avatarImage}></div>
        <p>Used in:</p>
        <ul>
          <li>Creative Browse</li>
          <li>Creative Profile</li>
          <li>Mobile Profile Menu</li>
        </ul>
      </div>
  
    </div>
  </section>;

export { ExampleAvatars }



// WEBPACK FOOTER //
// ./styleguide/components/avatars.jsx